((app) => {
    app.provider("processorTrackApi", [function() {
        this.$get = ["dataFeedApiGateway", (dataFeedApiGateway) => {
            let service = {};

            // GETS
            service.getAllTracks = () => {
                return dataFeedApiGateway.get("/SftpAPI/FileProcessorTracks");
            };

            service.getDataSourceEntityName = (trackId) => {
                return dataFeedApiGateway.get("/SftpAPI/FileProcessorTracks/GetDataSourceEntityName/" + trackId);
            };

            service.getMappedTracks = () => {
                return dataFeedApiGateway.get("/SftpAPI/FileProcessorTracks/Mapped");
            };

            service.getAllProcessors = () => {
                return dataFeedApiGateway.get("/SftpAPI/FileProcessorTracks/Processors");
            };

            service.getFrequencyTypes = () => {
                return dataFeedApiGateway.get("/SftpAPI/FileProcessorTracks/FrequencyTypes");
            };

            // POSTS
            service.createTrack = (dataSourceEntityId, name, description) => {
                let body = { DataSourceEntityId: dataSourceEntityId, Name: name, Description: description };
                return dataFeedApiGateway.post("/SftpAPI/FileProcessorTracks", body);
            };

            // PUTS
            service.createXRef = (trackId, processorId) => {
                return dataFeedApiGateway.put("/SftpAPI/FileProcessorTracks/" + trackId + "/Processor/" + processorId);
            };

            service.updateFrequency = (track) => {
                let body = { FrequencyInterval: track.FileProcessorTrackFrequencyInterval, FrequencyType: track.FileProcessorTrackFrequencyType };
                return dataFeedApiGateway.put("/SftpAPI/FileProcessorTracks/" + track.FileProcessorTrackId + "/Frequency", body);
            };

            return service;
        }];
    }]);
})(window.app);
